import { newToolFilterOAuthMcp } from "../oauth.ts";

export const portMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://app.port.io/favicon.svg",
  // EU region (app.port.io); US-region organizations use
  // https://mcp.us.port.io/v1.
  url: "https://mcp.port.io/v1",
  label: "Port",
});
